var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2497 23.9638C13.3704 23.8431 13.5363 23.7727 13.7124 23.7727H29.6741C29.9658 23.7727 30.1116 24.1247 29.9055 24.3309L26.7523 27.484C26.6316 27.6047 26.4657 27.6751 26.2897 27.6751H10.3279C10.0362 27.6751 9.89038 27.3231 10.0966 27.1169L13.2497 23.9638Z",
    fill: "url(#paint0_linear_1610_289)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2497 12.1911C13.3754 12.0704 13.5414 12 13.7124 12H29.6741C29.9658 12 30.1116 12.352 29.9055 12.5582L26.7523 15.7113C26.6316 15.832 26.4657 15.9024 26.2897 15.9024H10.3279C10.0362 15.9024 9.89038 15.5504 10.0966 15.3442L13.2497 12.1911Z",
    fill: "url(#paint1_linear_1610_289)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7523 18.0397C26.6316 17.919 26.4657 17.8486 26.2897 17.8486H10.3279C10.0362 17.8486 9.89038 18.2007 10.0966 18.4068L13.2497 21.56C13.3704 21.6807 13.5363 21.7511 13.7124 21.7511H29.6741C29.9658 21.7511 30.1116 21.399 29.9055 21.1929L26.7523 18.0397Z",
    fill: "url(#paint2_linear_1610_289)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1610_289",
    x1: 28.1493,
    y1: 10.1164,
    x2: 17.1025,
    y2: 31.2755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1610_289",
    x1: 23.319,
    y1: 7.5946,
    x2: 12.2722,
    y2: 28.7537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1610_289",
    x1: 25.7188,
    y1: 8.84748,
    x2: 14.672,
    y2: 30.0066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.394784180a0c12303c36959a0a4378a0.svg";
export { ForwardRef as ReactComponent };